<template>
  <div class="staff-approval-container">
    <el-card>
      <template #header>
        <div class="card-header">
          <el-button @click="$router.push('/dashboard')" type="primary" plain style="margin-right: 10px;">
            返回首页
          </el-button>
          <span>服务人员审批</span>
          <el-button type="primary" @click="refreshList">刷新列表</el-button>
        </div>
      </template>
      
      <el-table
        v-loading="loading"
        :data="staffList"
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="nickname" label="昵称" width="120" />
        <el-table-column prop="gender" label="性别" width="80">
          <template #default="{ row }">
            {{ row.gender === '1' ? '男' : '女' }}
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="注册时间" width="180" />
        <el-table-column prop="status" label="状态" width="100">
          <template #default="{ row }">
            <el-tag :type="row.status === 0 ? 'warning' : 'success'">
              {{ row.status === 0 ? '待审批' : '已审批' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template #default="{ row }">
            <el-button
              v-if="row.status === 0"
              type="primary"
              size="small"
              :loading="row.approving"
              @click="handleApprove(row)"
            >
              审批通过
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import axios from 'axios'

export default {
  name: 'StaffApproval',
  setup() {
    const loading = ref(false)
    const staffList = ref([])
    
    // 获取待审批人员列表
    const fetchStaffList = async () => {
      loading.value = true
      try {
        const response = await axios.get('staff_users.php')
        if (response.data.code === 0) {
          staffList.value = response.data.data.map(item => ({
            ...item,
            approving: false
          }))
        } else {
          ElMessage.error(response.data.message || '获取数据失败')
        }
      } catch (error) {
        console.error('获取待审批人员列表失败:', error)
        ElMessage.error('获取数据失败')
      } finally {
        loading.value = false
      }
    }
    
    // 审批通过
    const handleApprove = async (row) => {
      try {
        row.approving = true
        const response = await axios.post('approve_staff.php', {
          staff_id: row.id
        })
        
        if (response.data.code === 0) {
          ElMessage.success('审批通过成功')
          // 从列表中移除已审批的人员
          staffList.value = staffList.value.filter(item => item.id !== row.id)
        } else {
          ElMessage.error(response.data.message || '审批失败')
        }
      } catch (error) {
        console.error('审批失败:', error)
        ElMessage.error('审批失败')
      } finally {
        row.approving = false
      }
    }
    
    // 刷新列表
    const refreshList = () => {
      fetchStaffList()
    }
    
    onMounted(() => {
      console.log('StaffApproval component mounted')
      console.log('Current route:', window.location.pathname)
      fetchStaffList()
    })
    
    return {
      loading,
      staffList,
      handleApprove,
      refreshList
    }
  }
}
</script>

<style scoped>
.staff-approval-container {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-table {
  margin-top: 20px;
}
</style> 